// Maps normalized unassigned jobs into AIEmpower payload shape

interface UnassignedJob {
  jobId: string;
  title: string;
  category: string | null;
  requiredSkills: string[];
  siteLocation: string | null;
  start: string | null;
  end: string | null;
  durationMinutes: number;
  priority?: number | null;
  notes?: string | null;
}

export function mapUnassignedJobs(jobs: UnassignedJob[]): { unassignedJobs: UnassignedJob[] } {
  // For now the normalized shape already matches the payload; just wrap
  return { unassignedJobs: jobs };
}
